/* Campagnethema: dagtimer en tijdgestuurde tekstwissels (sectie bn-timer zet window.BF_CFG en window.BF_SWAPS).
 * Dagtimer: elke tekst met "hh:mm:ss <label>" telt af naar het volgende resetuur (middernacht in de storetijdzone)
 * en begint dan opnieuw. Na BF_CFG.end verdwijnt de timer. Wissels: [{from, to, find, replace}] met ISO-tijden in UTC.
 * Werkt op tekstknopen, dus ook in de slider, de PDP-verkooppunten en de door AJAX herbouwde cart drawer.
 */
(function () {
  var cfg = window.BF_CFG || {};
  // ponytail: vast resetuur in UTC; bij een zomer/wintertijd-overgang binnen de campagne de brief opnieuw bouwen.
  var END = Date.parse(cfg.end || '2026-12-01T05:00:00Z');
  var RESET = typeof cfg.resetHourUtc === 'number' ? cfg.resetHourUtc : 5;
  var LABEL = cfg.label || 'ET';
  var RE = new RegExp('\\d\\d:\\d\\d:\\d\\d ' + LABEL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  var swaps = window.BF_SWAPS || [];
  var timers = [];

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function left(now) {
    var d = new Date(now);
    var next = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), RESET);
    if (next <= now) next += 864e5;
    var s = Math.floor((next - now) / 1000);
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60) + ' ' + LABEL;
  }

  function scan(root) {
    var now = Date.now(), w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      for (var i = 0; i < swaps.length; i++) {
        var s = swaps[i];
        if (now >= Date.parse(s.from) && now < Date.parse(s.to) && t.indexOf(s.find) > -1) t = t.split(s.find).join(s.replace);
      }
      if (t !== n.nodeValue) n.nodeValue = t;
      if (!n.bfTimer && RE.test(t)) { n.bfTimer = true; timers.push(n); }
    }
  }

  function tick() {
    var now = Date.now(), txt = left(now);
    for (var i = 0; i < timers.length; i++) {
      var n = timers[i];
      if (now >= END) { if (n.parentNode) n.parentNode.style.display = 'none'; continue; }
      var v = n.nodeValue.replace(RE, txt);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
  }

  function start() {
    scan(document.body);
    tick();
    setInterval(tick, 1000);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (a) { if (a.nodeType === 1 || a.nodeType === 3) scan(a.nodeType === 1 ? a : a.parentNode); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.BFTimer = { left: left };  // voor de zelftest in de console
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();